var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"recruit-block"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v("更新于："+_vm._s(_vm.time))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }